import React, { useState, useEffect, FC } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import MuxHelper from '../utils/MuxHelper';
import VideoPlayer from '../components/VideoPlayer';

import { useMetaMask } from '../context/MetaMaskContext';
import { BigNumber, ethers, getDefaultProvider, utils } from 'ethers';
import MyAwesomeLogoArtifacts from '../artifacts/contracts/MyAwesomeLogo.sol/MyAwesomeLogo.json';
import { MyAwesomeLogo } from '../@types/contracts/MyAwesomeLogo';

import MyToken1155Artifacts from '../artifacts/contracts/MyToken1155.sol/MyToken1155.json';
import { MyToken1155 } from '../@types/contracts/MyToken1155';

import toast from 'react-hot-toast';

import Header from '../components/Header';

type VideoProps = {};

const muxHelper = new MuxHelper();

const Video: FC<VideoProps> = () => {
  const { tokenId, mediaId } = useParams<{ tokenId: string; mediaId: string }>();
  const { metaMask } = useMetaMask();
  const [tokenURI, setTokenURI] = useState<null | string>(null);
  const [isOwnerOfToken, setIsOwnerOfToken] = useState<null | boolean>(false);
  const [muxData, setMuxData] = useState<null | { src: string; poster: string }>(null);

  // useEffect(() => {
  //   if (!metaMask.isConnected) return;
  //   if (!tokenId) return;

  //   getOwnerOf(tokenId);
  //   getTokenURI(tokenId);
  // }, [metaMask]);

  useEffect(() => {
    if (!metaMask.isConnected) return;
    if (!tokenId) return;

    getBalanceOf(tokenId);
  }, [metaMask]);

  function getBalanceOf(tokenId: string) {
    if (!metaMask.isConnected || !metaMask.addressNFT1155) return;

    const provider = new ethers.providers.Web3Provider(metaMask.provider);
    const contract = new ethers.Contract(metaMask.addressNFT1155, MyToken1155Artifacts.abi, provider) as MyToken1155;

    contract
      .balanceOf(metaMask.account || '', tokenId)
      .then(async (result) => {
        const balance = BigNumber.from(result).toNumber();
        if (balance > 0) {
          const tokenURI = await contract.uri(tokenId);
          console.log({ tokenURI });
          setIsOwnerOfToken(true);
          fetchTokenMetadata(tokenURI);
        }
      })
      .catch(console.error);
  }

  // function getOwnerOf(tokenId: string) {
  //   if (!metaMask.isConnected || !metaMask.addressNFT1155) return;

  //   const provider = new ethers.providers.Web3Provider(metaMask.provider);
  //   const contract = new ethers.Contract(
  //     metaMask.addressNFT1155,
  //     MyAwesomeLogoArtifacts.abi,
  //     provider,
  //   ) as MyAwesomeLogo;

  //   contract
  //     .ownerOf(tokenId)
  //     .then((owner) => {
  //       const tokenOwnerAddress = utils.getAddress(owner);
  //       const address = utils.getAddress(metaMask.account || '');
  //       setIsOwnerOfToken(tokenOwnerAddress === address);
  //     })
  //     .catch(console.error);
  // }

  // function getTokenURI(tokenId: string) {
  //   if (!metaMask.isConnected || !metaMask.addressNFT1155) return;

  //   const provider = new ethers.providers.Web3Provider(metaMask.provider);
  //   const contract = new ethers.Contract(
  //     metaMask.addressNFT1155,
  //     MyAwesomeLogoArtifacts.abi,
  //     provider,
  //   ) as MyAwesomeLogo;

  //   contract
  //     .tokenURI(tokenId)
  //     .then((result) => {
  //       const tokenURI = result;
  //       fetchTokenMetadata(tokenURI);
  //     })
  //     .catch(console.error);
  // }

  function fetchTokenMetadata(uri: string) {
    axios
      .get(uri)
      .then(async (res) => {
        const media = res.data.properties.medias.find(
          (item: { id: number; muxAssetsId: string }) => item.id === Number(mediaId),
        );

        if (media) {
          const { src, poster } = await muxHelper.fetchSourceByAssetId(media.muxAssetsId);
          if (src && poster) setMuxData({ src, poster });
        }
      })
      .catch((error: any) => toast.error(error.message));
  }

  console.log('metaMask', metaMask);

  return (
    <div>
      <Header />

      <div className="viewer" style={{ backgroundImage: "url('/images/viewer-background.png')" }}>
        <div style={{ textAlign: 'center' }}>
          {(!metaMask.isConnected || !isOwnerOfToken) && (
            <>
              <p>Connect your MetaMask wallet to play video</p>
              {/* {muxData && <img src={muxData.poster} />} */}
            </>
          )}
          {muxData && metaMask.isConnected && isOwnerOfToken && (
            <VideoPlayer src={muxData.src} poster={muxData.poster} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Video;
